<div edsGrid>
  <div edsRow>
    <div edsCol>
      <eds-section-header
        [title]="chartConfig.chartTitle"
        [level]="3"
        [size]="'h3'"
        [asOfLabel]="'products.as-of' | translate"
        [asOfDate]="navAsOfDate"
        [updateFrequency]="'products.updated-daily' | translate"
        [caveatPlacement]="chartConfig.caveatPlacement"
        [analyticsName]="chartConfig.chartTitle"
        [tooltip]="chartConfig.tooltip"
        edsSpacing="md"
      ></eds-section-header>
      <eds-proximal
        [placement]="chartConfig.proximalPlacementTop"
      ></eds-proximal>
    </div>
  </div>

  <div
    edsSpacing="md"
    edsSubGrid="layout-7"
    edsSubGridTablet="layout-7"
    class="print-full-width"
  >
    <eds-dropdown
      ariaLabel="Dropdown"
      [dropdownId]="getDropdownId"
      name="pricingChartDropDown"
      [label]="'products.TIME_PERIOD' | translate: fundId"
      [titleText]="selectedDropdownTitleText"
      [items]="dropdownRange"
      (dropdownChange)="setDropdownDateRange($event)"
    ></eds-dropdown>
    <div
      edsFlexbox
      [justifyContent]="(isMobile$ | async) === false ? 'flex-end' : ''"
      [flexWrap]="(isMobile$ | async) === false ? 'wrap' : ''"
      flexDirection="row"
      alignItems="flex-start"
      class="dp-input-container"
      edsPadding
      [edsPaddingTop]="(isMobile$ | async) === false ? 'none' : 'sm'"
    >
      <div
        edsFlexbox
        alignItems="center"
        [flexDirection]="(isMobile$ | async) === false ? 'row' : 'column'"
      >
        <eds-duet-date-picker
          [siteConfigDateFormat]="siteConfigDateFormat"
          type="day"
          [id]="getFromDateId"
          [label]="'products.calendar-from' | translate"
          [min]="minDateStd"
          [max]="toDateStd"
          [value]="fromDateStd"
          (datePickerOpened)="datePickerOpened($event)"
          (datePickerClosed)="datePickerClosed($event)"
          (selected)="setCustomDateRange('fromDate', $event)"
          [opens]="(isMobile$ | async) === false ? 'left' : 'right'"
          [errorMsgObj]="errorMsgObj"
          [calendarHeading]="'common.date-picker-calendar-heading' | translate"
          [closeLabel]="'common.date-picker-close' | translate"
          [prevMonthLabel]="'common.date-picker-previous-button' | translate"
          [nextMonthLabel]="'common.date-picker-next-button' | translate"
          [monthSelectLabel]="'common.date-picker-select-month' | translate"
          [yearSelectLabel]="'common.date-picker-select-year' | translate"
          [selectedDateMessage]="'common.date-picker-selected-date' | translate"
          [buttonLabel]="'common.date-picker-button' | translate"
          [removeMargin]="isMobile$ | async"
        ></eds-duet-date-picker>
      </div>
      <div
        edsFlexbox
        alignItems="center"
        [flexDirection]="(isMobile$ | async) === false ? 'row' : 'column'"
      >
        <eds-duet-date-picker
          [siteConfigDateFormat]="siteConfigDateFormat"
          type="day"
          [id]="getToDateId"
          [label]="'products.calendar-to' | translate"
          [min]="fromDateStd"
          [max]="maxDateStd"
          [value]="toDateStd"
          (datePickerOpened)="datePickerOpened($event)"
          (datePickerClosed)="datePickerClosed($event)"
          (selected)="setCustomDateRange('toDate', $event)"
          [opens]="(isMobile$ | async) === false ? 'left' : 'right'"
          [errorMsgObj]="errorMsgObj"
          [calendarHeading]="'common.date-picker-calendar-heading' | translate"
          [closeLabel]="'common.date-picker-close' | translate"
          [prevMonthLabel]="'common.date-picker-previous-button' | translate"
          [nextMonthLabel]="'common.date-picker-next-button' | translate"
          [monthSelectLabel]="'common.date-picker-select-month' | translate"
          [yearSelectLabel]="'common.date-picker-select-year' | translate"
          [selectedDateMessage]="'common.date-picker-selected-date' | translate"
          [buttonLabel]="'common.date-picker-button' | translate"
          [removeMargin]="isMobile$ | async"
        ></eds-duet-date-picker>
      </div>
    </div>
  </div>

  <div edsRow>
    <div edsCol class="pricing-chart__container print-full-width">
      <highcharts-chart
        *ngIf="highcharts"
        [Highcharts]="highcharts"
        [options]="chartOptions"
        style="width: 100%; height: 400px; display: block"
      ></highcharts-chart>
      <eds-proximal
        [placement]="chartConfig.proximalPlacementBottom"
      ></eds-proximal>
    </div>
  </div>
</div>
